/* 軽い演出だけを追加。機種選択・カート・決済は既存テーマが担当。 */
const MCE_EDITORIAL_I18N = (() => { try { return JSON.parse(document.querySelector('[data-mce-i18n="editorial"]').textContent); } catch (e) { return {}; } })();
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const init = (scope = document) => {
    scope.querySelectorAll('[data-mce-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const buttons = [...gallery.querySelectorAll('[data-mce-choice]')];
      const frames = [...gallery.querySelectorAll('[data-mce-ink]')];
      const screen = gallery.querySelector('[data-mce-ink-screen]');
      let current = 0, request = 0, timers = [];
      const choose = async button => {
        if (gallery.dataset.mceScroll === 'true') return;
        const next = Number(button.dataset.mceChoice);
        const token = ++request;
        timers.forEach(clearTimeout); timers = [];
        screen.classList.remove('is-refreshing');
        if (next === current) return;
        try { await frames[next].decode(); } catch { return; }
        if (token !== request || !gallery.isConnected || gallery.dataset.mceScroll === 'true') return;
        const commit = () => {
          if (token !== request || !gallery.isConnected || gallery.dataset.mceScroll === 'true') return;
          current = next;
          frames.forEach((frame, i) => { frame.classList.toggle('is-current', i === next); frame.setAttribute('aria-hidden', String(i !== next)); });
          buttons.forEach(b => b.setAttribute('aria-pressed', String(b === button)));
          const caption = gallery.querySelector('[data-mce-caption]');
          if (caption) caption.textContent = button.textContent;
        };
        if (reduced.matches) { commit(); return; }
        // 連続操作でも書き換えを最初から始める。
        void screen.offsetWidth;
        screen.classList.add('is-refreshing');
        timers.push(setTimeout(commit, 120));
        timers.push(setTimeout(() => { if (token === request) screen.classList.remove('is-refreshing'); }, 2000));
      };
      buttons.forEach((button, i) => {
        button.addEventListener('click', () => choose(button));
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (i + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
          buttons[next].focus(); choose(buttons[next]);
        });
      });
      let startX;
      screen.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, {passive:true});
      screen.addEventListener('touchend', e => { if(startX === undefined) return; const d=e.changedTouches[0].clientX-startX; startX=undefined; if(Math.abs(d)>65) choose(buttons[(current+(d<0?1:buttons.length-1))%buttons.length]); }, {passive:true});
    });
    scope.querySelectorAll('[data-mce-video-open]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      const dialog = document.getElementById(button.getAttribute('aria-controls'));
      if (!dialog) return;
      const video = dialog.querySelector('video');
      button.addEventListener('click', () => {
        dialog.showModal();
        if (!video.getAttribute('src')) video.src = video.dataset.mceVideoSrc;
        video.play().catch(() => {});
      });
      dialog.querySelector('[data-mce-video-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', e => { if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if(e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close(); } });
      dialog.addEventListener('close', () => { video.pause(); button.focus(); });
      video.addEventListener('error', () => { dialog.querySelector('.mce-video-error').hidden = false; });
    });
    const reviews = document.querySelector('[id*="judge_me_reviews_homepage"]');
    if (reviews && !document.getElementById('mce-reviews')) {
      const anchor = document.createElement('span'); anchor.id = 'mce-reviews'; reviews.prepend(anchor);
    }
  };
  document.querySelectorAll('[data-mce-buy]').forEach(link => {
    const picker = document.querySelector('quantity-breaks, variant-selects, variant-radios, .product-form__input');
    const info = document.querySelector('product-info');
    const target = picker || info;
    if (target) {
      if (!target.id) target.id = 'mce-product-selection';
      link.href = '#' + target.id;
      link.addEventListener('click', e => {
        e.preventDefault();
        // 数量と機種が選択済みならカートに入れてそのままチェックアウトへ。未選択なら選択欄へ戻す。
        if (window.mceBuySelectionValid?.() && window.mceBuySelectionItems && !link.dataset.mceBusy) {
          link.dataset.mceBusy = 'true'; link.setAttribute('aria-busy', 'true');
          const root = window.Shopify?.routes?.root || '/';
          fetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({items:window.mceBuySelectionItems()})})
            .then(r => { if (!r.ok) throw r; location.href = root + 'checkout'; })
            .catch(() => { delete link.dataset.mceBusy; link.removeAttribute('aria-busy'); target.scrollIntoView({block:'center'}); });
          return;
        }
        target.scrollIntoView({behavior:reduced.matches ? 'auto' : 'smooth', block:'center'});
        const input = target.querySelector('select, input:not([type="hidden"]), button');
        if (input) input.focus({preventScroll:true});
      });
    }
  });
  // ネイティブカートの変更に合わせて共通ナビの点数を更新する。
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, async () => {
      try {
        const response = await fetch((window.routes?.cart_url || '/cart') + '.js', {headers:{Accept:'application/json'}});
        if (!response.ok) return;
        const cart = await response.json();
        document.querySelectorAll('.mce-bag').forEach(bag => {
          const count = bag.querySelector('.mce-bag-count');
          if (count) count.textContent = cart.item_count ? String(cart.item_count) : '';
          bag.setAttribute('aria-label', (MCE_EDITORIAL_I18N.bag_aria || '{{count}}').replace('{{count}}', cart.item_count));
          if (bag.hasAttribute('data-mce-sticky-cart')) bag.hidden = cart.item_count === 0;
        });
        document.querySelector('[data-mce-sticky-buy]')?.classList.toggle('has-cart', cart.item_count > 0);
      } catch { /* カート本体の操作はブロックしない。 */ }
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

/* F2 / S1: 一度だけ再生して同じ構図の静止画に着地。 */
(() => {
  const instances = new Map();
  const mount = scene => {
    if (instances.has(scene)) return;
    const video = scene.querySelector('[data-mce-intro]');
    const button = scene.querySelector('[data-mce-pause]');
    if (!video) return;
    const retry = scene.querySelector('[data-mce-intro-retry]');
    // Safariでは属性だけでなく、読み込み前にプロパティも確定する。
    video.muted = true; video.defaultMuted = true; video.playsInline = true;
    // 取り外しの流れを保ちながら、表示時間を約25%短縮する。
    if (scene.hasAttribute('data-mce-power-motion')) video.defaultPlaybackRate = video.playbackRate = 4 / 3;
    const source = matchMedia('(max-width: 749px)').matches && video.dataset.mobileSrc ? video.dataset.mobileSrc : video.dataset.src;
    const frames = [...scene.querySelectorAll('[data-mce-frame]')];
    const media = scene.querySelector('.mce-stand-media, .mce-power-media');
    video.autoplay = !media;
    let hasStarted = false, firstCompleted = false;
    const caption = scene.querySelector('[data-mce-scene-caption]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const abort = new AbortController();
    let paused = reduced.matches || Boolean(navigator.connection?.saveData);
    // data-mce-intro-skip: 冒頭動画を再生せず、着地後の静止画＋柄の切替から始める。
    let complete = paused || scene.hasAttribute('data-mce-intro-skip'), visible = false, disposed = false, current = 0;
    let timer, release, watchdog, refresh, settle, generation = 0, starting = false;
    const screen = scene.querySelector('[data-mce-ink-screen]');
    if (complete) { scene.dataset.motionState = 'poster'; if (retry) retry.hidden = false; }
    scene.dataset.titleVisible = String(complete);
    const ready = () => !paused && visible && !document.hidden && !disposed;
    const labels = ['和のアート', '花のイラスト', 'ポートレート'];
    const ui = () => {
      if (!button) return;
      if (scene.matches('[data-mce-stand-motion], [data-mce-power-motion]')) scene.dataset.controlsReady = String(firstCompleted || (!hasStarted && paused) || Boolean(scene.dataset.playbackError));
      button.setAttribute('aria-pressed', String(paused));
      button.setAttribute('aria-label', complete && !frames.length ? (scene.hasAttribute('data-mce-power-motion') ? (MCE_EDITORIAL_I18N.replay_power || '') : (MCE_EDITORIAL_I18N.replay_stand || '')) : paused ? (MCE_EDITORIAL_I18N.resume || '') : (MCE_EDITORIAL_I18N.pause || ''));
      button.querySelector('span').textContent = complete && !frames.length ? '↻' : paused ? '▷' : 'Ⅱ';
    };
    const stopTimer = () => { generation++; clearTimeout(timer); clearTimeout(watchdog); clearTimeout(refresh); clearTimeout(settle); screen?.classList.remove('is-refreshing'); };
    const advance = async () => {
      if (!ready()) return;
      const request = ++generation, next = (current + 1) % frames.length, frame = frames[next];
      try {
        if (!frame.getAttribute('src')) {
          if (frame.dataset.srcset) frame.srcset = frame.dataset.srcset;
          frame.src = frame.dataset.src;
        }
        await frame.decode();
        if (request !== generation || !ready()) return;
        const commit = () => {
          if (request !== generation || !ready()) return;
          frames.forEach((f, i) => { f.classList.toggle('is-current', i === next); f.setAttribute('aria-hidden', String(i !== next)); });
          current = next;
        };
        if (!screen || reduced.matches) commit();
        else {
          screen.classList.add('is-refreshing');
          refresh = setTimeout(commit, 120);
          settle = setTimeout(() => { screen.classList.remove('is-refreshing'); if (request === generation) sync(); }, 2000);
          return;
        }
      } catch (_) { /* 失敗時は現在の静止画を保持。 */ }
      if (request === generation) sync();
    };
    const finish = (immediate = false) => {
      if (disposed) return;
      complete = true; starting = false; video.pause(); stopTimer();
      scene.dataset.motionState = 'poster';
      scene.dataset.titleVisible = 'true';
      clearTimeout(release); release = setTimeout(() => { video.removeAttribute('src'); video.load(); }, 800);
      ui(); sync();
      if (immediate && frames.length > 1 && ready()) { clearTimeout(timer); advance(); }
    };
    const unavailable = reason => {
      if (disposed || complete) return;
      scene.dataset.playbackError = reason;
      if (retry) retry.hidden = false;
      finish();
    };
    const sync = () => {
      stopTimer();
      if (!ready()) { video.pause(); return; }
      if (complete) { if (frames.length > 1) timer = setTimeout(advance, scene.hasAttribute('data-mce-intro-skip') ? 1500 : 2200); return; } // 商品ページFVは柄の表示を1.5秒（2026-10-07）
      if (!video.getAttribute('src')) { video.preload = 'auto'; video.src = source; }
      // 下部の短い動画は先読みし、短い先行バッファを確保してから始める。
      if (media && video.readyState < 4) {
        const end = video.buffered?.length ? video.buffered.end(video.buffered.length - 1) : 0;
        if (!Number.isFinite(video.duration) || end < Math.min(video.duration, video.currentTime + (scene.hasAttribute('data-mce-power-motion') ? .4 : 1))) {
          watchdog = setTimeout(() => { if (!complete) unavailable('buffer-timeout'); }, 20000);
          return;
        }
      }
      if (!starting && video.paused) {
        starting = true;
        Promise.resolve(video.play()).then(() => { starting = false; if (!ready()) video.pause(); else if (video.paused && !complete) sync(); }).catch(error => { starting = false; if (disposed) return; if (error.name === 'AbortError') { if (ready()) sync(); return; } if (ready()) unavailable(error.name || 'play-rejected'); });
      }
      watchdog = setTimeout(() => { if (!complete) unavailable('play-timeout'); }, 15000);
    };
    video.addEventListener('playing', () => { if (!complete && ready()) { hasStarted = true; if (retry) retry.hidden = true; delete scene.dataset.playbackError; scene.dataset.motionState = 'playing'; ui(); } }, {signal:abort.signal});
    video.addEventListener('timeupdate', () => { if (video.currentTime >= Number(scene.dataset.revealAt || 2.5)) scene.dataset.titleVisible = 'true'; }, {signal:abort.signal});
    video.addEventListener('ended', () => { firstCompleted = true; finish(true); }, {signal:abort.signal});
    video.addEventListener('error', () => { if (!complete) unavailable('media-' + (video.error?.code || 'error')); }, {signal:abort.signal});
    retry?.addEventListener('click', () => {
      clearTimeout(release); stopTimer(); complete = false; paused = false; starting = false;
      scene.dataset.motionState = 'loading'; scene.dataset.titleVisible = 'false';
      retry.hidden = true; video.currentTime = 0;
      // ユーザー操作のイベント内で直接play()まで実行する。
      ui(); sync();
    }, {signal:abort.signal});
    button?.addEventListener('click', () => {
      if (complete && !frames.length) { clearTimeout(release); complete = false; paused = false; scene.dataset.motionState = 'loading'; video.currentTime = 0; }
      else paused = !paused;
      ui(); sync();
    }, {signal:abort.signal});
    document.addEventListener('visibilitychange', sync, {signal:abort.signal});
    reduced.addEventListener('change', () => { paused = reduced.matches; if (paused && !complete) finish(); ui(); sync(); }, {signal:abort.signal});
    const warmObserver = media ? new IntersectionObserver(entries => {
      if (entries.some(e => e.isIntersecting) && !paused && !complete && !disposed && !document.hidden && !video.getAttribute('src')) {
        video.preload = 'auto'; video.src = source; video.load();
      }
    }, {rootMargin:'1000px 0px',threshold:0}) : null;
    warmObserver?.observe(media);
    ['loadedmetadata','canplay','canplaythrough','progress'].forEach(event => video.addEventListener(event, () => {
      if (!complete && video.paused && !starting && ready()) sync();
    }, {signal:abort.signal}));
    const observer = new IntersectionObserver(entries => {
      visible = entries.some(e => e.isIntersecting && (!media || e.intersectionRatio >= (hasStarted ? .1 : .35)));
      sync();
    }, media ? {threshold:[0,.1,.35],rootMargin:'-64px 0px 0px 0px'} : {threshold:.2});
    observer.observe(media || scene); ui();
    instances.set(scene, () => { disposed = true; stopTimer(); clearTimeout(release); observer.disconnect(); warmObserver?.disconnect(); abort.abort(); video.pause(); video.removeAttribute('src'); video.load(); });
  };
  const init = () => document.querySelectorAll('[data-mce-scene], [data-mce-stand-motion], [data-mce-power-motion]').forEach(mount);
  init(); document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    for (const [scene, dispose] of instances) if (event.target.contains(scene)) { dispose(); instances.delete(scene); }
  });
})();

/* 継続セールは期限を付けず割引率を表示する。 */
(() => {
 const update = () => document.querySelectorAll('[data-mce-monthly-sale]').forEach(el => { el.textContent = `${el.dataset.discount || 30}%OFF`; el.removeAttribute('title'); el.nextElementSibling?.matches('.mce-sale-renewal') && el.nextElementSibling.remove(); });
 update(); document.addEventListener('shopify:section:load', update);
})();

/* 中央揃えの行末約物は半角分をぶら下げ、文字の見た目を中央へ。 */
(() => {
 const align = () => document.querySelectorAll('.mce-site :is(h1,h2,h3), .mce-site .mce-eyebrow').forEach(el => {
  if (el.dataset.opticalReady || getComputedStyle(el).textAlign !== 'center' || el.querySelector('a,button,img,svg')) return;
  const mark = line => {
   line.classList.add('mce-optical-line');
   if (/[、。，．！？]$/.test(line.textContent.trim())) line.classList.add('mce-optical-punctuation');
  };
  if ([...el.children].length && [...el.children].every(n => n.tagName === 'SPAN')) [...el.children].forEach(mark);
  else if ([...el.children].every(n => n.tagName === 'BR')) {
   const makeLine = () => { const span = document.createElement('span'); span.style.color = 'inherit'; return span; };
   const fragment = document.createDocumentFragment(); let line = makeLine();
   [...el.childNodes].forEach(n => {
    if (n.nodeName === 'BR') { mark(line); fragment.append(line,n); line = makeLine(); }
    else line.append(n);
   });
   mark(line);fragment.append(line);el.replaceChildren(fragment);
  }
  el.dataset.opticalReady = 'true';
 });
 align(); addEventListener('resize',align); document.addEventListener('shopify:section:load',align);
})();

/* 共通の登場演出：透明からゆっくり上昇。カードは左から順に。 */
(() => {
 const reduced = matchMedia('(prefers-reduced-motion: reduce)');
 const mounted = new WeakSet();
 const sequences = new WeakMap();
 const observers = new Set();
 const init = () => {
  if (reduced.matches || !('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
   if (!entry.isIntersecting) return;
   const targets = sequences.get(entry.target) || [entry.target];
   targets.forEach(el => {
    if (el.classList.contains('mce-drop-ready')) {
     const rect = el.getBoundingClientRect();
     el.style.setProperty('--mce-drop-x', `${innerWidth / 2 - rect.left - rect.width / 2}px`);
     el.style.setProperty('--mce-drop-y', `${innerHeight + 28 - rect.top - rect.height / 2}px`);
     el.style.setProperty('--mce-drop-apex', `${Math.min(200, innerHeight * .24)}px`);
    }
    el.classList.add('mce-in');
   });
   observer.unobserve(entry.target);
  }), {threshold:.18, rootMargin:`0px 0px -${Math.round(innerHeight * .18)}px 0px`});
  observers.add(observer);
  const mount = (el, kind = 'mce-rise', delay = 0, observe = true) => {
   if (mounted.has(el)) return;
   mounted.add(el); el.classList.add(...kind.split(' ')); el.style.setProperty('--mce-enter-delay', `${delay}ms`);
   if (observe) observer.observe(el);
  };
  document.querySelectorAll('.mce-section :is(h1,h2,h3,p), .mce-film :is(h2,p), .mh-home :is(h1,h2,h3,p)').forEach(el => {
   if (el.closest('dialog, .mce-slide, .mh-designs figure, .mce-power-summary, .mce-float-art, .jdgm-widget') || !el.textContent.trim()) return;
   mount(el);
  });
  document.querySelectorAll('.mce-slide-track, .mh-designs').forEach(track => {
   const cards = [...track.children].filter(el => el.matches('.mce-slide, figure'));
   if (!cards.length || mounted.has(cards[0])) return;
   cards.forEach((el,i) => mount(el,'mce-rise',i * 190,false));
   sequences.set(cards[0],cards); observer.observe(cards[0]);
  });
  document.querySelectorAll('.mce-gallery .mce-vertical-product').forEach(el => mount(el,'mce-rise mce-phone-rise',350));
  document.querySelectorAll('[data-mce-video-open].mce-film__poster--text').forEach(el => mount(el,'mce-drop-ready'));
 };
 init();
 reduced.addEventListener('change', () => {
  if (reduced.matches) {
   observers.forEach(o=>o.disconnect());
   document.querySelectorAll('.mce-rise,.mce-drop-ready').forEach(el=>el.classList.add('mce-in'));
  } else init();
 });
 document.addEventListener('shopify:section:load',init);
})();
